import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";

const initialState = {
  getAddressesSuccessfully: false,
  addressesData: {
    _embedded: {}
  }
};

export default {
  name: "addresses",
  actions: {
    loadAddresses: payload => dispatch({ type: "LOAD_ADDRESSES", payload }),
    fetchAddresses: async function () {
      dispatch({ type: "FETCH_ADDRESSES" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/customers/addresses`,
        {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (response.ok) {
        const data = await response.json();
        this.loadAddresses(data);
      } else {
        window.logApiErrors(
          "r",
          "fetchAddresses",
          response.status,
          response.statusText
        );
      }
    },
    removeAddress: async function (address) {
      dispatch({ type: "DELETE_ADDRESS" });
      // await req.delete({
      //   api: "addresses",
      //   params: address.id
      // });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/customers/addresses/${address.id}`,
        {
          credentials: "include",
          method: "DELETE",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (!response.ok) {
        window.logApiErrors(
          "r",
          "removeAddress",
          response.status,
          response.statusText
        );
      }
    },
    newAddress: async function (address) {
      dispatch({ type: "NEW_ADDRESS" });
      // await req.post({
      //   api: "addresses",
      //   body: address
      // });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/customers/addresses`,
        {
          credentials: "include",
          method: "POST",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify(address)
        }
      );
      if (!response.ok) {
        window.logApiErrors(
          "r",
          "newAddress",
          response.status,
          response.statusText
        );
      }
    },
    editAddress: async function (address, id) {
      dispatch({ type: "EDIT_ADDRESS" });
      // await req.patch({
      //   api: "addresses",
      //   body: address,
      //   params: id
      // });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/customers/addresses/${id}`,
        {
          credentials: "include",
          method: "PATCH",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify(address)
        }
      );
      if (!response.ok) {
        window.logApiErrors(
          "r",
          "editAddress",
          response.status,
          response.statusText
        );
      }
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "LOAD_ADDRESSES":
        return {
          ...state,
          getAddressesSuccessfully: true,
          addressesData: action.payload
        };
      default:
        return state;
    }
  }
};
